import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_CREATE_COLLECTION_CONSTANT_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_CONSTANT_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_CONSTANT_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createCollectionConstant(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_CONSTANT_BEGIN,
    });
    const { projectId, version, collectionUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constants/${collectionUuid}/collection`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_CONSTANT_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Created collection constant');
            toast.success('Constant Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_CONSTANT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create collection constant');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_CONSTANT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create collection constant');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionConstantError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_CONSTANT_BEGIN:
      return {
        ...state,
        createCollectionConstantPending: true,
        createCollectionConstantError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTANT_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        createCollectionConstantPending: false,
        createCollectionConstantError: null,
        projectCollections,
        selectedCollection: action.data,
      };
    case COLLECTIONS_CREATE_COLLECTION_CONSTANT_FAILURE:
      return {
        ...state,
        createCollectionConstantPending: false,
        createCollectionConstantError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR:
      return {
        ...state,
        createCollectionConstantError: null,
      };

    default:
      return state;
  }
}
